import {store} from '@/plugins/vuex';
import i18n from '@/shared/i18n';
import _ from 'lodash';
import MarketingService from '@/modules/marketing/MarketingService';
import CustomerSearch from '@/modules/marketing/customers/CustomerSearch.model';
import CustomerIdentificationFormModel from '@/modules/customer/models/CustomerIdentificationForm.model';
import {MARKETING_CUSTOMER_TABLE_NAME} from "../../constants";
import {hasPermission} from "@/core/directives/permission";

let getDefaultTableData = (differentFields = []) => {
  let defaultFields = ['no', 'full_name', 'company_name', 'email', 'address', 'phone', 'status', 'activity',
    'interest_categories', 'optin'];
  if (!hasPermission('view_customeraddress')) {
    defaultFields = defaultFields.filter(f => f !== 'address');
  }
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new CustomerSearch(),
    extraFilters: {},
    expand: '',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['no', 'full_name'],
      defaultFields: defaultFields,
    }
  }
};

const customerIdentificationModel = new CustomerIdentificationFormModel();
let getDefaultFields = () => {
  let fields = [
    {key: 'no', label: i18n.t('No'), sortable: true, tdClass: 'no-col', isVisible: true, expand: ''},
    {
      key: 'full_name',
      label: i18n.t('Full Name'),
      sortable: true,
      tdClass: 'fullname-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'company_name',
      label: i18n.t('Company Name'),
      sortable: true,
      tdClass: 'company-name-col',
      isVisible: true,
      expand: ''
    },
    {key: 'email', label: i18n.t('Email'), sortable: true, tdClass: 'email-col', isVisible: true, expand: ''},
    {
      key: 'address',
      label: i18n.t('Billing Address'),
      sortable: true,
      tdClass: 'address-col',
      isVisible: true,
      expand: 'display_billing_address'
    },
    {key: 'phone', label: i18n.t('Phone'), sortable: true, tdClass: 'phone-col', isVisible: true, expand: ''},
    {key: 'status', label: i18n.t('Status'), sortable: true, tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: "account_managers",
      label: i18n.t('Account Manager'),
      sortable: false,
      isVisible: false,
      expand: 'account_managers',
      tdClass: "account-managers-col"
    },
    {key: 'optin', label: i18n.t('Optin'), sortable: true, isVisible: true, tdClass: 'optin-col', expand: ''},
    {key: 'tags', label: i18n.t('Tags'), sortable: false, isVisible: false, tdClass: 'tags-col', expand: ''},
    {
      key: 'is_company',
      label: i18n.t('Is Company'),
      sortable: true,
      tdClass: 'is-company-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'sms_optin',
      label: i18n.t('Text Message Notification Optin'),
      sortable: true,
      tdClass: 'sms-optin-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'mark_optin',
      label: i18n.t('Mark. Optin'),
      sortable: true,
      tdClass: 'mark-optin-col',
      isVisible: false,
      expand: 'mark_optin'
    },
    {
      key: 'personal_id',
      label: i18n.t('Personal ID'),
      sortable: true,
      tdClass: 'personal-id-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'shipping_address',
      label: i18n.t('Shipping/Collection Address'),
      sortable: true,
      tdClass: 'shipping-address-col',
      isVisible: false,
      expand: 'display_shipping_address'
    },
    {
      key: 'enable_estimate_request',
      label: i18n.t('Estimate Request'),
      sortable: true,
      tdClass: 'enable-estimate-request-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_data'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_data'
    },
    {
      key: 'birth_date',
      label: i18n.t('Date of Birth'),
      sortable: true,
      tdClass: 'birth-date-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'is_vendor',
      label: i18n.t('Vendor'),
      sortable: true,
      tdClass: 'is-vendor-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'gender',
      label: i18n.t('Gender'),
      sortable: true,
      tdClass: 'gender-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'type',
      label: i18n.t('Type'),
      sortable: true,
      tdClass: 'type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'accounting_code',
      label: i18n.t('Accounting Code'),
      sortable: false,
      tdClass: 'accounting_code-col',
      isVisible: false,
      expand: 'accounting_code'
    },
    {
      key: 'trust_level',
      label: i18n.t('Trust Level'),
      sortable: false,
      tdClass: 'trust_level-col',
      isVisible: false,
      expand: 'trust_level_display_name'
    },
    {
      key: 'credit_card_verified_at',
      label: i18n.t('Credit Card Verified at'),
      sortable: true,
      tdClass: 'credit_card_verified_at-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'personal_identification_number',
      label: customerIdentificationModel.attributeLabels.personal_identification_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_type',
      label: customerIdentificationModel.attributeLabels.document_type,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_number',
      label: customerIdentificationModel.attributeLabels.document_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_issue_date',
      label: customerIdentificationModel.attributeLabels.document_issue_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_expiry_date',
      label: customerIdentificationModel.attributeLabels.document_expiry_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'date_of_birth',
      label: customerIdentificationModel.attributeLabels.date_of_birth,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'citizenship_code',
      label: customerIdentificationModel.attributeLabels.citizenship_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification.citizenship'
    },
    {
      key: 'residency_code',
      label: customerIdentificationModel.attributeLabels.residency_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification.residency'
    },
    {
      key: 'country_of_birth_code',
      label: customerIdentificationModel.attributeLabels.country_of_birth_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification.country_of_birth'
    },
    {
      key: 'place_of_issue',
      label: customerIdentificationModel.attributeLabels.place_of_issue,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'company_reg_number',
      label: customerIdentificationModel.attributeLabels.company_reg_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'audiences',
      label: i18n.t('Audiences'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'audiences'
    },
    {
      key: 'billing_address_country',
      label: i18n.t('Billing Address Country'),
      sortable: false,
      tdClass: 'country-col',
      isVisible: false,
      expand: 'billing_address.country'
    },
    {
      key: 'billing_address_address_1',
      label: i18n.t('Billing Address Address 1'),
      sortable: false,
      tdClass: 'address_1-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_address_2',
      label: i18n.t('Billing Address Address 2'),
      sortable: false,
      tdClass: 'address_2-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_city',
      label: i18n.t('Billing Address City'),
      sortable: false,
      tdClass: 'city-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_county',
      label: i18n.t('Billing Address County'),
      sortable: false,
      tdClass: 'county-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_state',
      label: i18n.t('Billing Address State'),
      sortable: false,
      tdClass: 'state-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_zip_code',
      label: i18n.t('Billing Address Zip/Postcode'),
      sortable: false,
      tdClass: 'zip_code-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'billing_address_email',
      label: i18n.t('Billing Address Email'),
      sortable: false,
      tdClass: 'email-col',
      isVisible: false,
      expand: 'billing_address'
    },
    {
      key: 'bank_account_name',
      label: i18n.t('Bank Account Name/Beneficiary'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_account_number',
      label: i18n.t('Bank Account Number'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_sort_code',
      label: i18n.t('Bank Sort Code'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_name',
      label: i18n.t('Bank Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'iban',
      label: i18n.t('IBAN'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'swift',
      label: i18n.t('Swift'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_address',
      label: i18n.t('Bank Address 1'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_address_2',
      label: i18n.t('Bank Address 2'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_address_3',
      label: i18n.t('Bank Address 3'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_first_name',
      label: i18n.t('Bank Contact First Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_last_name',
      label: i18n.t('Bank Contact Last Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'bank_email',
      label: i18n.t('Bank Contact Email'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'bank_account'
    },
    {
      key: 'shipping_address_country',
      label: i18n.t('Shipping Address Country'),
      sortable: false,
      tdClass: 'country-col',
      isVisible: false,
      expand: 'shipping_address.country'
    },
    {
      key: 'shipping_address_address_1',
      label: i18n.t('Shipping Address Address 1'),
      sortable: false,
      tdClass: 'address_1-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_address_2',
      label: i18n.t('Shipping Address Address 2'),
      sortable: false,
      tdClass: 'address_2-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_city',
      label: i18n.t('Shipping Address City'),
      sortable: false,
      tdClass: 'city-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_county',
      label: i18n.t('Shipping Address County'),
      sortable: false,
      tdClass: 'county-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_state',
      label: i18n.t('Shipping Address State'),
      sortable: false,
      tdClass: 'state-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_zip_code',
      label: i18n.t('Shipping Address Zip/Postcode'),
      sortable: false,
      tdClass: 'zip_code-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'shipping_address_email',
      label: i18n.t('Shipping Address Email'),
      sortable: false,
      tdClass: 'email-col',
      isVisible: false,
      expand: 'shipping_address'
    },
    {
      key: 'total_hammer_buyer',
      label: i18n.t('Total Hammer (Buyer)'),
      sortable: false,
      tdClass: 'total-hammer-buyer-col',
      isVisible: false,
      expand: 'total_hammer_buyer'
    },
    {
      key: 'total_hammer_seller',
      label: i18n.t('Total Hammer (Seller)'),
      sortable: false,
      tdClass: 'total-hammer-seller-col',
      isVisible: false,
      expand: 'total_hammer_seller'
    },
    {
      key: 'total_invoice_buyer',
      label: i18n.t('Total Invoice (Buyer)'),
      sortable: false,
      tdClass: 'total-invoice-buyer-col',
      isVisible: false,
      expand: 'total_invoice_buyer'
    },
    {
      key: 'total_settlement_seller',
      label: i18n.t('Total Settlement (Seller)'),
      sortable: false,
      tdClass: 'total-settlement-seller-col',
      isVisible: false,
      expand: 'total_settlement_seller'
    },
    {
      key: 'single_hammer_buyer',
      label: i18n.t('Single Hammer (Buyer)'),
      sortable: false,
      tdClass: 'single-hammer-buyer-col',
      isVisible: false,
      expand: 'single_hammer_buyer'
    },
    {
      key: 'single_hammer_seller',
      label: i18n.t('Single Hammer (Seller)'),
      sortable: false,
      tdClass: 'single-hammer-seller-col',
      isVisible: false,
      expand: 'single_hammer_seller'
    }
  ]

  if (!hasPermission('view_customerbankaccount')) {
    let bankFields = [
      'bank_account_name',
      'bank_account_number',
      'bank_sort_code',
      'bank_name',
      'iban',
      'swift',
      'bank_address',
      'bank_address_2',
      'bank_address_3',
      'bank_first_name',
      'bank_last_name',
      'bank_email',
    ]

    fields = fields.filter(f => !bankFields.includes(f.key))
  }

  if (!hasPermission('view_customeraddress')) {
    let addressFields = [
      'address',
      'billing_address_country',
      'billing_address_address_1',
      'billing_address_address_2',
      'billing_address_city',
      'billing_address_county',
      'billing_address_state',
      'billing_address_zip_code',
      'billing_address_email',
      'shipping_address_country',
      'shipping_address_address_1',
      'shipping_address_address_2',
      'shipping_address_city',
      'shipping_address_county',
      'shipping_address_state',
      'shipping_address_zip_code',
      'shipping_address_email'
    ]
    fields = fields.filter(f => !addressFields.includes(f.key))
  }

  return fields
}

const customer = {
  namespaced: true,
  state: {
    tableData: getDefaultTableData(),
  },
  actions: {
    initTableData({state}) {
      state.tableData = getDefaultTableData();
    },
    resetTableDataPaginationPage({state}) {
      state.tableData.pagination.page = 1;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await MarketingService.getMarketingCustomers(params);
      commit('updateTableLoading', false);
      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData.extraFilters;
      const expand = state.tableData.expand;
      const tmpToggleColumns = _.cloneDeep(state.tableData.toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData.pagination.limit;
      state.tableData = defaultTableData;
      state.tableData.toggleColumns = tmpToggleColumns;
      state.tableData.extraFilters = extraFilters;
      state.tableData.expand = expand;
      dispatch('getTableData');
    },
    async getTableParams({state}, payload = null) {
      let data;
      let tableData = state.tableData;
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: tableData,
        tableName: MARKETING_CUSTOMER_TABLE_NAME
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...tableData.pagination,
          search: tableData.search,
          ordering: ordering,
        }
      }

      if (tableData.searchModel) {
        const searchModelData = tableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      const defaultExpand = tableData.expand
      const expand = [
        ...new Set(
          tableData.toggleColumns.fields
            .filter(c => tableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
            .map(c => c.expand)
        )
      ].join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    async addCustomersToAudience({commit, dispatch}, payload) {
      let params;
      if (payload['customers'].size) {
        params = {
          customer_uuids: Array.from(payload['customers'].values(), x => x.uuid)
        }
      } else {
        params = await dispatch('getTableParams');
      }
      commit('updateTableLoading', true);
      const response = await MarketingService.addCustomersToAudience(payload['audience_uuid'], params);
      commit('updateTableLoading', false);
      return response;
    }
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData = {...state.tableData, ...payload},
    updateTableLoading: (state, payload) => state.tableData.loading = payload,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData.toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData.toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData.toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData.toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
};

export default customer;
